import { getLogger } from '../logging/logger';

const ArcadeSkins = {};
const logger = getLogger('ArcadeSkinManager');

class ArcadeSkinManager {
	/**
	 * Registers an arcade skin that can be loaded dynamicalyl at runtime. This is typically handled within the Arcade module itself.
	 *
	 * @param {string | object} id - The id of the skin or an object with key => value pairs of an ID to a function that will import the skin scss file.
	 * @param {function} importer - A function that will import the skin scss file.
	 */
	registerSkin(id, importer = null) {
		logger.log(`[${this.registerSkin.name}]`, { id, importer });

		if (typeof id === 'object') {
			// Handle object that maps skin id to the importer function that can be called
			Object.entries(id).forEach(([skinId, skinImporter]) =>
				this.registerSkin(skinId, skinImporter),
			);
		} else if (typeof id === 'string' && typeof importer === 'function') {
			// Handle plain
			ArcadeSkins[id] = importer;
		} else {
			logger.warn('Invalid id or importer supplied for registering arcade skin', {
				id,
				importer,
			});
		}
	}

	/**
	 * Dynamically loads a skin by it's id. The skin may need additional class names to be added to the HTML body to be activated.
	 *
	 * @param {string} id - The id of the skin to load
	 * @returns {Promise} - Resolves when the skin is loaded. Rejects if the skin is not available.
	 */
	loadSkin(id) {
		logger.log(`[${this.loadSkin.name}]`, id);

		if (ArcadeSkins[id]) {
			return ArcadeSkins[id]();
		}

		return Promise.reject(new Error(`Arcade skin "${id}" not registered`));
	}
}

export default new ArcadeSkinManager();
